"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_box_common_1 = require("../il-box/il-box.common");
var il_form_label_common_1 = require("../il-form-label/il-form-label.common");
var il_textfield_common_1 = require("../il-textfield/il-textfield.common");
var il_button_common_1 = require("../il-button/il-button.common");
var formik_1 = require("formik");
var login_validation_1 = require("./login.validation");
var Box_1 = __importDefault(require("@mui/material/Box"));
var il_password_field_1 = require("../il-password-field/il-password-field");
var LoginForm = function (props) {
    var formik = (0, formik_1.useFormik)({
        initialValues: {
            usernameOrEmail: '',
            password: '',
        },
        validationSchema: props.promptForEmailOnly ? login_validation_1.EmailOnlyLoginValidation : login_validation_1.LoginValidation,
        onSubmit: function (values) {
            props.onSubmit(values);
        },
    });
    return (react_1.default.createElement(Box_1.default, { sx: { maxWidth: enums_1.BreakpointsEnum.MEDIUM } },
        react_1.default.createElement(il_box_common_1.ILFormBox, null,
            react_1.default.createElement(material_1.Typography, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    textAlign: 'center',
                    paddingBottom: { sm: '1rem', md: '3rem' },
                }, color: 'text.primary', variant: enums_1.TypographyVariantEnum.H2 }, props.headingText),
            react_1.default.createElement("form", { onSubmit: formik.handleSubmit },
                props.errorMessage && (react_1.default.createElement(material_1.Typography, { sx: {
                        display: 'flex',
                        justifyContent: 'center',
                        textAlign: 'center',
                        py: 1,
                        fontSize: 'button.fontSize',
                        lineHeight: 1.62,
                        fontWeight: 'normal',
                        textTransform: 'unset',
                    }, color: enums_1.ColorPaletteEnum.ERROR, variant: enums_1.TypographyVariantEnum.H3 }, props.errorMessage)),
                react_1.default.createElement(il_box_common_1.ILFormItemBox, null,
                    props.promptForEmailOnly ? (react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Email Address")) : (react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Username or Email Address")),
                    react_1.default.createElement(il_textfield_common_1.LoginTextField, { id: 'usernameOrEmail', value: formik.values.usernameOrEmail, placeholder: props.promptForEmailOnly ? 'Your Email' : 'Your Username or Email', onChange: formik.handleChange, error: Boolean(formik.errors.usernameOrEmail), helperText: formik.errors.usernameOrEmail })),
                react_1.default.createElement(il_box_common_1.ILFormItemBox, { sx: __assign(__assign({}, il_box_common_1.ILFormItemBoxArgs.sx), { marginBottom: '0.5rem', gap: 1, mt: 0 }) },
                    react_1.default.createElement(il_form_label_common_1.BoldFormLabel, null, "Password"),
                    react_1.default.createElement(il_password_field_1.ILPasswordField, { id: 'password', value: formik.values.password, placeholder: "Your Password", onChange: formik.handleChange, error: Boolean(formik.errors.password), helperText: formik.errors.password })),
                props.forgotPasswordLink && (react_1.default.createElement(material_1.Typography, { sx: {
                        display: 'flex',
                        justifyContent: 'left',
                        textAlign: 'center',
                        py: 1,
                        fontSize: 'button.fontSize',
                        lineHeight: 1.62,
                        fontWeight: 'normal',
                        textTransform: 'unset',
                    }, color: enums_1.ColorPaletteEnum.INFO, variant: enums_1.TypographyVariantEnum.H3 },
                    react_1.default.createElement(material_1.Link, { sx: { textDecoration: 'none' }, href: props.forgotPasswordLink }, "Forgot Password?"))),
                props.forgotPasswordCustomText && (react_1.default.createElement(material_1.Typography, { sx: {
                        display: 'flex',
                        justifyContent: 'left',
                        textAlign: 'center',
                        py: 1,
                        fontSize: 'button.fontSize',
                        lineHeight: 1.62,
                        fontWeight: 'normal',
                        textTransform: 'unset',
                    }, color: enums_1.ColorPaletteEnum.INFO, variant: enums_1.TypographyVariantEnum.H3 }, props.forgotPasswordCustomText)),
                react_1.default.createElement(il_button_common_1.ContainedButton, { disabled: !(formik.isValid && formik.dirty), sx: __assign(__assign({}, il_button_common_1.ContainedButtonArgs.sx), { width: '100%', mt: '1.5rem' }), type: enums_1.ButtonTypeEnum.SUBMIT }, "Login"))),
        props.signUpLink && (react_1.default.createElement(material_1.Typography, { sx: {
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                py: 1,
                fontSize: 'button.fontSize',
                lineHeight: 1.62,
                fontWeight: 'normal',
                textTransform: 'unset',
            }, color: enums_1.ColorPaletteEnum.INFO, variant: enums_1.TypographyVariantEnum.H3 },
            "Don't have an account? \u00A0",
            react_1.default.createElement(material_1.Link, { sx: { textDecoration: 'none' }, href: props.signUpLink }, "Sign up for free!"))),
        props.signUpCustomText && (react_1.default.createElement(material_1.Typography, { sx: {
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                py: 1,
                fontSize: 'button.fontSize',
                lineHeight: 1.62,
                fontWeight: 'normal',
                textTransform: 'unset',
            }, color: enums_1.ColorPaletteEnum.INFO, variant: enums_1.TypographyVariantEnum.H3 }, props.signUpCustomText))));
};
exports.LoginForm = LoginForm;
